// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"5e8dc131","175":"902beb50","554":"8c97f064","663":"3c353358","738":"40d7bec0"}[chunkId] + ".chunk.js";
};